<mat-sidenav-container class="mainWrapper blue_theme  light-theme background-image" autosize autoFocus dir="ltr">

  <!-- ============================================================== -->
  <!-- Main Content -->
  <!-- ============================================================== -->
  <mat-sidenav-content class="p-l-24 p-r-24" #content>

    <main class="pageWrapper maxWidth">
      <!-- ============================================================== -->
      <!-- VerticalHeader -->
      <!-- ============================================================== -->

      <ng-container>
        <app-header [showToggle]="false" (toggleCollapsed)="true" [disableLink]="disableHeaderLink"></app-header>
      </ng-container>


      <div class="m-t-30">

        <!-- ============================================================== -->
        <!-- Outlet -->
        <!-- ============================================================== -->
        <router-outlet></router-outlet>
      </div>

    </main>
  </mat-sidenav-content>
</mat-sidenav-container>